import z from "zod";

import { createIdSchema } from "@/schemas/createId";

export const ReferenceBaseSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  title: z.string().nullable(),
  organization: z.string().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
});
export type ReferenceBase = z.infer<typeof ReferenceBaseSchema>;

/** Core collects how the referee knows the candidate; no other source asks. */
export const ReferenceSchema = ReferenceBaseSchema.extend({
  relationship: z.string().nullish(),
  yearsKnown: z.string().nullish(),
});
export type Reference = z.infer<typeof ReferenceSchema>;

export const ReferenceCreateSchema = ReferenceSchema.extend({
  id: createIdSchema,
});
export type ReferenceCreate = z.infer<typeof ReferenceCreateSchema>;
